import './Carosel.css'
import HeaderCarosel from './Header_Carosel'

const HCarosel = ({pageName}) => {
  return <HeaderCarosel pageName={pageName} />
}
export default HCarosel
